import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 29 29",
  "content": "<symbol viewBox=\"0 0 29 29\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\">\n<path d=\"M14.1422 28.2842L12.7279 26.87L25.4559 14.142H28.2843L14.1422 28.2842Z\" />\n<path d=\"M12.7279 24.0415L11.3137 25.4557L1.3113e-05 14.142L2.82844 14.142L12.7279 24.0415Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol